<template>
  <div class="body_right">
    <div class="right_container">
      <div class="right_title">
        <div class="title">직원 목록</div>
        <div class="description">직원 내역을 조회하고 관리합니다.</div>
        <article class="right_body">
          <!--검색툴 -->
          <div class="tbl_search seach_mobile">
            <table>
              <colgroup>
                <col style="width: 15%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>재직상태별</th>
                  <td>
                    <div class="inner_td">
                      <button
                        type="button"
                        :class="{ on: SearchStatus === 'T' }"
                        @click="updateStatus('T')"
                      >
                        전체보기
                      </button>
                      <button
                        type="button"
                        :class="{ on: SearchStatus === 'A' }"
                        @click="updateStatus('A')"
                      >
                        재직
                      </button>
                      <button
                        type="button"
                        :class="{ on: SearchStatus === 'L' }"
                        @click="updateStatus('L')"
                      >
                        휴직
                      </button>
                      <button
                        type="button"
                        :class="{ on: SearchStatus === 'I' }"
                        @click="updateStatus('I')"
                      >
                        인턴
                      </button>
                      <button
                        type="button"
                        :class="{ on: SearchStatus === 'P' }"
                        @click="updateStatus('P')"
                      >
                        수습
                      </button>
                      <button
                        type="button"
                        :class="{ on: SearchStatus === 'R' }"
                        @click="updateStatus('R')"
                      >
                        퇴직
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>키워드검색</th>
                  <td>
                    <div class="inner_td">
                      <select v-model="SearchType">
                        <option value="userName">이름</option>
                        <option value="userDeptName">소속</option>
                        <option value="userPosition">직책</option>
                        <option value="userMobile">휴대폰번호</option>
                      </select>
                      <input
                        type="text"
                        v-model="SearchKey"
                        class="pop_text"
                        placeholder="검색어를 입력해주세요"
                        @keyup.enter="handleSearchKeyEnter"
                      />
                      <button type="button" @click="handleSearchKeyEnter">
                        검색
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- //검색툴 -->
          <div class="count_page">
            <div class="count_num">
              <span>총</span>
              <span
                class="accent_color bold"
                style="margin-left: 2px; margin-right: 2px"
              >
                {{ this.totalEmployees }}
              </span>
              <span>건</span>
              <select v-model="itemsPerPage" @change="handleItemsPerPageChange">
                <option selected="selected" value="5">5</option>
                <option value="10">10</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="300">300</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
              </select>
              <span>명씩</span>
            </div>
            <button type="button" @click="addUser">등록하기</button>
          </div>
          <div class="right_contents">
            <!--목록-->
            <div
              v-if="employeeList.length > 0"
              class="tbl_list table_m mobile_table"
            >
              <table>
                <colgroup>
                  <col style="width: 5%" />
                  <col style="width: 6%" />
                  <col style="width: 15%" />
                  <col />
                  <col style="width: 12%" />
                  <col style="width: 20%" />
                  <col style="width: 8%" />
                </colgroup>
                <thead class="no_mobile">
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        v-model="allSelected"
                        @change="toggleAllSelections"
                      />
                    </th>
                    <th>
                      <a href="###">번호</a>
                      <img src="@/images/up_icon_s.png" style="display: none" />
                      <img
                        src="@/images/down_icon_s.png"
                        style="display: none"
                      />
                    </th>
                    <th @click="sort('userName')" class="sortable">
                      <a>이름</a>
                      <img
                        v-if="OrderType === 'userName_asc'"
                        src="@/images/up_icon_s.png"
                      />
                      <img
                        v-if="OrderType === 'userName_desc'"
                        src="@/images/down_icon_s.png"
                      />
                    </th>
                    <th @click="sort('deptName')" class="sortable">
                      <a>소속</a>
                      <img
                        v-if="OrderType === 'deptName_asc'"
                        src="@/images/up_icon_s.png"
                      />
                      <img
                        v-if="OrderType === 'deptName_desc'"
                        src="@/images/down_icon_s.png"
                      />
                    </th>
                    <th @click="sort('positionName')" class="sortable">
                      <a>직책</a>
                      <img
                        v-if="OrderType === 'positionName_asc'"
                        src="@/images/up_icon_s.png"
                      />
                      <img
                        v-if="OrderType === 'positionName_desc'"
                        src="@/images/down_icon_s.png"
                      />
                    </th>
                    <th><a href="###">휴대폰번호</a></th>
                    <th><a href="###">재직상태</a></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="employee in paginatedEmployees"
                    :key="employee.userId"
                    class="no_move"
                    :data-user-id="employee.userId"
                    :data-company-id="employee.companyId"
                  >
                    <td>
                      <input
                        type="checkbox"
                        @change="toggleSelection(employee.userId)"
                        :checked="selectedEmployees.includes(employee.userId)"
                      />
                    </td>
                    <td class="no_mobile">{{ employee.no }}</td>
                    <td class="detail_page_a o2 o_title">
                      <div class="center_td">
                        <router-link
                          :to="{
                            name: 'EmployeesView',
                            params: { id: employee.userId },
                          }"
                          class="center_td"
                        >
                          <p class="text_bold long_p">
                            {{ employee.userName }}
                          </p>
                          <img src="@/images/detail_page.png" />
                        </router-link>
                      </div>
                    </td>
                    <td class="name o5">
                      <span class="only_mobile">소속 : </span>
                      <span>{{ employee.deptName }}</span>
                    </td>
                    <td class="phone o6r">
                      <span class="only_mobile">직책 : </span>
                      <span>{{ employee.position }}</span>
                    </td>
                    <td class="num phone o7">
                      <span class="only_mobile">휴대폰번호 : </span>
                      <span>{{ employee.userPhone }}</span>
                    </td>
                    <td class="center_td o_stat">
                      <div :class="getUserStatusClass(employee.userStatus)">
                        <span>{{
                          getUserStatusText(employee.userStatus)
                        }}</span>
                      </div>
                      <!-- <span>{{
                        employee.userStatus === "A"
                          ? "재직"
                          : employee.userStatus === "L"
                          ? "휴직"
                          : employee.userStatus === "I"
                          ? "인턴"
                          : employee.userStatus === "P"
                          ? "수습"
                          : employee.userStatus === "R"
                          ? "퇴직"
                          : ""
                      }}</span> -->
                    </td>
                  </tr>
                </tbody>
                <tbody style="display: none">
                  <tr class="no_data">
                    <td colspan="7">데이터가 없습니다</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="tbl_list table_m mobile_table">
              <table>
                <colgroup>
                  <col style="width: 5%" />
                  <col style="width: 6%" />
                  <col style="width: 15%" />
                  <col />
                  <col style="width: 12%" />
                  <col style="width: 20%" />
                  <col style="width: 8%" />
                </colgroup>
                <thead class="no_mobile">
                  <tr>
                    <th>
                      <input type="checkbox" />
                    </th>
                    <th>
                      <a href="###">번호</a>
                      <img src="@/images/up_icon_s.png" style="display: none" />
                      <img
                        src="@/images/down_icon_s.png"
                        style="display: none"
                      />
                    </th>
                    <th @click="sort('userName')" class="sortable">
                      <a>이름</a>
                      <img
                        v-if="OrderType === 'userName_asc'"
                        src="@/images/up_icon_s.png"
                      />
                      <img
                        v-if="OrderType === 'userName_desc'"
                        src="@/images/down_icon_s.png"
                      />
                    </th>
                    <th @click="sort('deptName')" class="sortable">
                      <a>소속</a>
                      <img
                        v-if="OrderType === 'deptName_asc'"
                        src="@/images/up_icon_s.png"
                      />
                      <img
                        v-if="OrderType === 'deptName_desc'"
                        src="@/images/down_icon_s.png"
                      />
                    </th>
                    <th @click="sort('positionName')" class="sortable">
                      <a>직책</a>
                      <img
                        v-if="OrderType === 'positionName_asc'"
                        src="@/images/up_icon_s.png"
                      />
                      <img
                        v-if="OrderType === 'positionName_desc'"
                        src="@/images/down_icon_s.png"
                      />
                    </th>
                    <th><a>휴대폰번호</a></th>
                    <th><a>재직상태</a></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="no_data">
                    <td colspan="7">데이터가 없습니다</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--//목록-->
          </div>
          <div class="list_bottom">
            <div>
              <button type="button" @click.prevent="delUserSelected">
                삭제
              </button>
            </div>
          </div>
          <!-- 페이징 -->
          <div class="page_num">
            <div class="pageing">
              <a
                href="###"
                v-if="hasPrevPageGroup"
                @click.prevent="prevPageGroup"
                ><img src="@/images/front_n.png" alt="처음페이지"
              /></a>
              <a href="###" v-if="hasPrevPage" @click.prevent="prevPage"
                ><img src="@/images/prev_n.png" alt="이전페이지"
              /></a>
              <a
                v-for="page in pageGroup"
                :key="page"
                href="###"
                :class="{ on: currentPage === page }"
                @click.prevent="goToPage(page)"
              >
                {{ page }}
              </a>
              <a href="###" v-if="hasNextPage" @click.prevent="nextPage"
                ><img src="@/images/next_n.png" alt="다음페이지"
              /></a>
              <a
                href="###"
                v-if="hasNextPageGroup"
                @click.prevent="nextPageGroup"
                ><img src="@/images/end_n.png" alt="마지막페이지"
              /></a>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/apiClient"; // 설정 파일에서 가져온 axios 인스턴스
import { useToast } from "vue-toastification";

export default {
  name: "EmployeesList",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      employeeList: [], // 직원 목록 데이터를 저장할 배열
      selectedEmployees: [], // 선택된 직원 목록의 userId를 저장할 배열
      currentPage: 1, // 현재 페이지
      itemsPerPage: 10, // 페이지 당 항목 수
      pageGroupSize: 5, // 하단 페이지 나오는 수 ( 1-5 / 6-10 > 5개씩 )
      SearchType: "userName", // 검색 키 (dropdownlist)
      SearchKey: "", // 검색 textbox 값
      SearchStatus: "T", // 재직상태 전체보기(Total)로 기본세팅. * 재직상태[ 재직 : A(Active) / 휴직 : (L)Leave / 인턴 : I(Intern) / 수습 : P(Probation) / 퇴직 : R(Retired) ] 로 구분.
      OrderType: "",
      totalEmployees: 0, // 총 직원 수
    };
  },
  computed: {
    userId() {
      return this.$store.getters.getUserid;
    },
    userName() {
      return this.$store.getters.getUsername;
    },
    userType() {
      return this.$store.getters.getUsertype;
    },
    userPermission() {
      return this.$store.getters.getUserpermission;
    },
    companyid() {
      return this.$store.getters.getCompanyid;
    },
    allSelected: {
      get() {
        return (
          this.selectedEmployees.length > 0 &&
          this.selectedEmployees.length === this.employeeList.length
        );
      },
      set(value) {
        if (value) {
          this.selectedEmployees = this.employeeList.map(
            (employee) => employee.userId
          );
        } else {
          this.selectedEmployees = [];
        }
      },
    },
    paginatedEmployees() {
      if (!Array.isArray(this.employeeList)) {
        return [];
      }

      const start = 0;
      const end = this.itemsPerPage;
      return this.employeeList.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.totalEmployees / this.itemsPerPage);
    },
    pageGroup() {
      const start =
        Math.floor((this.currentPage - 1) / this.pageGroupSize) *
          this.pageGroupSize +
        1;
      const end = Math.min(start + this.pageGroupSize - 1, this.totalPages);
      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    hasPrevPageGroup() {
      return this.currentPage > 1;
    },
    hasNextPageGroup() {
      return this.currentPage < this.totalPages;
    },
    hasPrevPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
  },
  methods: {
    toggleAllSelections() {
      if (this.allSelected) {
        this.selectedEmployees = this.employeeList.map(
          (employee) => employee.userId
        );
      } else {
        this.selectedEmployees = [];
      }
    },
    toggleSelection(userId) {
      const selectedEmployee = this.employeeList.find(
        (employee) => employee.userId === userId
      );

      if (!selectedEmployee) return;

      const relatedEmployees = this.employeeList.filter(
        (employee) =>
          employee.userId === selectedEmployee.userId &&
          employee.companyId === selectedEmployee.companyId
      );

      const isSelected = this.selectedEmployees.includes(userId);

      if (isSelected) {
        relatedEmployees.forEach((employee) => {
          const index = this.selectedEmployees.indexOf(employee.userId);
          if (index > -1) {
            this.selectedEmployees.splice(index, 1);
          }
        });
      } else {
        relatedEmployees.forEach((employee) => {
          if (!this.selectedEmployees.includes(employee.userId)) {
            this.selectedEmployees.push(employee.userId);
          }
        });
      }
    },
    async fetchData() {
      try {
        const searchParam = {
          Page: this.currentPage,
          PageSize: this.itemsPerPage,
          OrderType: this.OrderType,
          CompanyId: this.companyid,
          SearchActiveStatus: this.SearchStatus,
          SearchType: this.SearchType,
          SearchKey: this.SearchKey,
        };

        const response = await apiClient.post(
          "/api/User/all-user-list",
          searchParam
        );

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.employeeList = Array.isArray(data.data) ? data.data : [];
          this.totalEmployees = data.meta.totalCount || 0;
        }
      } catch (error) {
        console.error("Error fetching userList data:", error);
      }
    },
    updateStatus(status) {
      this.SearchStatus = status;
      this.currentPage = 1; // 상태 변경 시 페이지를 1로 리셋
      this.employeeList = []; // 회사 목록 초기화
      this.fetchData();
    },
    addUser() {
      this.$router.push({ path: "/employee/add" });
    },
    delUserSelected() {
      if (this.selectedEmployees.length === 0) {
        this.toast.error("삭제를 원하시는 직원 리스트를 선택해주세요.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 1.5초 동안 표시 (오타 수정)
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });

        return;
      }

      const message = "선택된 직원을 삭제 처리하시겠습니까?";

      if (confirm(message)) {
        this.delUser(this.selectedEmployees);
      }
    },
    async delUser(selectedIds) {
      try {
        const promises = selectedIds.map(async (id) => {
          return apiClient.post("/api/User/user-del", {
            UserId: id,
            LoginUserId: localStorage.getItem("userid"),
          });
        });

        const responses = await Promise.all(promises);

        responses.forEach((response, index) => {
          if (response.status !== 200) {
            console.error(`Failed to user-del for ID ${selectedIds[index]}`);
          }
        });

        this.selectedEmployees = [];
        this.allSelected = false; // thead 체크박스 해제
        this.fetchData();
      } catch (error) {
        console.error("Error user-del:", error);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.employeeList = []; // 페이지 변경 시 목록 초기화
        this.fetchData(); // 페이지가 변경될 때마다 데이터 다시 가져오기
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.employeeList = []; // 페이지 변경 시 목록 초기화
        this.fetchData(); // 페이지가 변경될 때마다 데이터 다시 가져오기
      }
    },
    nextPageGroup() {
      this.currentPage = this.totalPages;
      this.employeeList = []; // 페이지 변경 시 목록 초기화
      this.fetchData(); // 페이지가 변경될 때마다 데이터 다시 가져오기
    },
    prevPageGroup() {
      this.currentPage = 1;
      this.employeeList = []; // 페이지 변경 시 목록 초기화
      this.fetchData(); // 페이지가 변경될 때마다 데이터 다시 가져오기
    },
    goToPage(page) {
      this.currentPage = page;
      this.employeeList = []; // 페이지 변경 시 목록 초기화
      this.fetchData();
    },
    handleItemsPerPageChange() {
      this.currentPage = 1; // itemsPerPage 변경 시 페이지를 1로 리셋
      this.employeeList = []; // 페이지 변경 시 목록 초기화
      this.fetchData();
    },

    // A-재직 / L-휴직 / I-인턴 / P-수습 / R-퇴직
    // 상태에 따른 문구 반환
    getUserStatusText(status) {
      switch (status) {
        case "A":
          return "재직";
        case "L":
          return "휴직";
        case "I":
          return "인턴";
        case "P":
          return "수습";
        case "R":
          return "퇴직";
        default:
          return "알 수 없음";
      }
    },
    getUserStatusClass(status) {
      switch (status) {
        case "A":
          return "stat back_green"; // 재직 back_green
        case "L":
          return "stat back_orange"; // 휴직
        case "I":
          return "stat back_yellow"; // 인턴
        case "P":
          return "stat back_purple"; // 수습
        case "R":
          return "stat back_grey"; // 퇴직
        default:
          return "stat back_default"; // 기본 값
      }
    },

    handleSearchKeyEnter() {
      this.currentPage = 1; // itemsPerPage 변경 시 페이지를 1로 리셋
      this.employeeList = []; // 페이지 변경 시 목록 초기화
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style>
.sortable {
  cursor: pointer;
}
</style>
